import * as React from 'react'
import { createRoot } from 'react-dom/client'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import './index.css'
import './i18n'
import App from './App'
import Maintenance from './components/maintenance'
import { BUILD_ENV, NODE_ENV } from './helpers/utils'

const { version } = require('../package.json')

// Unhandled Errors, deren oberster Frame nicht aus unserem Bundle stammt,
// kommen von Fremdcode (Browser-Extensions, Mail-Link-Scanner, In-App-
// Browser), der z.B. Node.prototype.appendChild patcht und DOM-Nodes per
// JSON.stringify serialisiert ("Converting circular structure to JSON").
const isThirdPartyError = (event) => {
  if (!event.unhandled) return false

  const frames = event.errors[0]?.stacktrace || []
  const topFrame = frames.find(
    ({ file }) => file && !file.includes('native code')
  )

  return !!topFrame && !topFrame.file.startsWith(window.location.origin)
}

Bugsnag.start({
  apiKey: '7c890e68e7fb0f7c5f696dbff265d81e',
  appVersion: version,
  releaseStage: BUILD_ENV,
  enabledReleaseStages: ['production', 'staging', 'develop'],
  plugins: [new BugsnagPluginReact()],
  onError: (event) => {
    if (NODE_ENV === 'development') return false
    if (isThirdPartyError(event)) return false

    event.addMetadata('partner', {
      partner_id: localStorage.getItem('partner-id'),
      partner_name: localStorage.getItem('partner-name'),
      career_id: localStorage.getItem('career-id'),
      partner_user_id: localStorage.getItem('partner-user-id'),
      space_id: localStorage.getItem('space-id')
    })

    // Fallback-User, falls setUser im Flow noch nicht lief
    if (!event.getUser().id) {
      event.setUser(localStorage.getItem('partner-user-id') || undefined)
    }
  }
})

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

const container = document.getElementById('root')
const root = createRoot(container) // createRoot(container!) if you use TypeScript

root.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={Maintenance}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
)
